export default class Palette {
    static KOMUNE_YELLOW = "#febe10";
    static MAIN_THEME = "#EC1D26";

    static THEME_YELLOW = "#febe10";
    static THEME_PURPLE = "#7f8fea";
    static THEME_GREEN = "#43936C";
    static THEME_RED = "#004EEB";

    static BACKGROUND_BLACK = "#121212";
    static BACKGROUND_DARK_GRAY = "#1d1d1d";
    static INACTIVE_GRAY = "#c2c2c2";
    static LIGHT_GRAY = "#404040";
    static WHITE_GRAY = "#757575";
    static WHITE = '#FFF';
}
